import { utils, writeFileXLSX } from 'xlsx';
import startCase from 'lodash/startCase';

const tableXlsxExport = (data, fileName, tableAPI, userRole) => {
  try {
    const excelData = tableAPI.getExcelData(data, userRole);
    const excelColumns = tableAPI.getExcelColumns();
    const COL_WIDTH = 25;
    const COL_NUMBER = excelColumns.length;
    const workbook = utils.book_new();

    if (excelData.constructor === Object) {
      Object.entries(excelData).forEach((entry) => {
        const [key, value] = entry;
        const worksheet = utils.json_to_sheet(value);
        utils.book_append_sheet(workbook, worksheet, startCase(key));
        utils.sheet_add_aoa(worksheet, [excelColumns], { origin: 'A1' });
        worksheet['!cols'] = Array(COL_NUMBER).fill({ wch: COL_WIDTH });
      });
    } else {
      const worksheet = utils.json_to_sheet(excelData);
      utils.book_append_sheet(workbook, worksheet, fileName);
      utils.sheet_add_aoa(worksheet, [excelColumns], { origin: 'A1' });
      worksheet['!cols'] = Array(COL_NUMBER).fill({ wch: COL_WIDTH });
    }

    writeFileXLSX(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.log(error);
  }
};

export default tableXlsxExport;
